import { render, staticRenderFns } from "./AddCustomTag.vue?vue&type=template&id=ee01c604&"
import script from "./AddCustomTag.vue?vue&type=script&lang=ts&"
export * from "./AddCustomTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports